import { useEffect, useState } from "react";
import AgentBuilderApprovalList from "../../components/super-admin/approvals/AgentBuilderApprovalList";
import OwnerApprovalList from "../../components/super-admin/approvals/OwnerApprovalList";
import PropertyApprovalList from "../../components/super-admin/approvals/PropertyApprovalList";
import api from "../../configs/api";
import { capitalize } from "../../utils/helpers";

const SuperAdminApprovalRequest = () => {
  const TAB_KEY = "superAdminActiveApprovalTab";

  const [activeTab, setActiveTab] = useState(() => {
    return localStorage.getItem(TAB_KEY) || "agent-builder";
  });

  useEffect(() => {
    localStorage.setItem(TAB_KEY, activeTab);
  }, [activeTab]);

  const [data, setData] = useState({
    "agent-builder": { count: 0, list: [] },
    owner: { count: 0, list: [] },
    properties: { count: 0, list: [] },
  });

  const [loading, setLoading] = useState(true);

  const tabs = [
    { key: "agent-builder", label: "Agent / Builder" },
    { key: "owner", label: "Owner" },
    { key: "properties", label: "Properties" },
  ];

  useEffect(() => {
    fetchAllApprovals();
  }, []);

  const fetchAllApprovals = async () => {
    try {
      setLoading(true);

      const [agentRes, ownerRes, propertyRes] = await Promise.all([
        api.get("/approvals/agent-builders"),
        api.get("/approvals/owners"),
        api.get("/approvals/properties"),
      ]);

      console.log("agentRes", agentRes);
      setData({
        "agent-builder": {
          count: agentRes.data.count,
          list: agentRes.data.list,
        },
        owner: {
          count: ownerRes.data.count,
          list: ownerRes.data.list,
        },
        properties: {
          count: propertyRes.data.count,
          list: propertyRes.data.list,
        },
      });
    } catch (err) {
      console.error("Error loading approval lists:", err);
    } finally {
      setLoading(false);
    }
  };

  const renderTabContent = () => {
    switch (activeTab) {
      case "agent-builder":
        return (
          <AgentBuilderApprovalList
            list={data["agent-builder"].list}
            refresh={fetchAllApprovals}
            loading={loading}
          />
        );

      case "owner":
        return (
          <OwnerApprovalList
            list={data.owner.list}
            refresh={fetchAllApprovals}
            loading={loading}
          />
        );

      case "properties":
        return (
          <PropertyApprovalList
            list={data.properties.list}
            refresh={fetchAllApprovals}
            loading={loading}
          />
        );

      default:
        return <div>Select a tab</div>;
    }
  };

  return (
    <div className="min-h-screen font-quicksand bg-background py-4 px-4">
      {/* Header */}
      <div className="bg-[#616587] mb-4 p-6 rounded-3xl border-2">
        <h1 className="text-white font-poppins text-2xl italic">
          Request Approval
        </h1>
        <p className="text-white opacity-80 text-sm">
          {capitalize(activeTab)} Approval Queue
        </p>
      </div>

      {/* Tabs */}
      <div className="w-full border-b border-[#DCDCDC]">
        <div className="flex gap-1">
          {tabs.map((tab) => (
            <button
              key={tab.key}
              onClick={() => setActiveTab(tab.key)}
              className={`font-poppins px-6 py-2 text-base border-x border-t rounded-t-md transition-all flex items-center gap-2
                ${
                  activeTab === tab.key
                    ? "bg-[#616587] text-white border-[#616587]"
                    : "bg-[#F7F7FA] text-[#616587] border-[#E0E0E0] hover:bg-[#E9E9F0]"
                }
              `}
            >
              {tab.label}

              {/* Count Bubble */}
              <span
                className={`px-2.5 py-[2px] text-xs rounded-full 
                  ${
                    activeTab === tab.key
                      ? "bg-white text-[#616587]"
                      : "bg-[#616587] text-white"
                  }
                `}
              >
                {data[tab.key].count}
              </span>
            </button>
          ))}
        </div>
      </div>

      {/* Tab Content */}
      <div>{renderTabContent()}</div>
    </div>
  );
};

export default SuperAdminApprovalRequest;
